<p>user-vehicule-details-container works!</p>
<router-outlet></router-outlet>